
<section class="mx-auto px-4 sm:px-6 lg:px-0 bg-white">
    <section class="lg:container lg:mx-auto py-5 lg:px-8">
        <h2 class="text-center text-4xl font-semibold mb-3">Our <span class="text-primary">Card Type</span></h2>
        <p class="text-center text-secondary-light">Select the right card for you and get Customize your card</p>

      

        <table class="min-w-full rounded-lg border shadow-sm mt-5 text-sm lg:text-base     ">
            <thead class="bg-primary  ">
                <tr>
                    <th scope="col" class="py-3 lg:px-6  text-center text-white  ">
                    </th>
                    <th scope="col" class="py-3 lg:px-6  text-center text-white border-solid border-x border-white ">
                        MYTAG Standard
                    </th>
                    <th scope="col" class="py-3 lg:px-6  text-center text-white border-solid border-x border-white ">
                        MYTAG Personal
                    </th>
                    <th scope="col" class="py-3 lg:px-6  text-center text-white border-solid border-x border-white ">
                        MYTAG Business
                    </th>
                </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">

                <tr>
                    <td class="py-4 px-1 lg:px-6 font-bold bg-slate-200">Features</td>
                    <td class="py-4 px-1 lg:px-6 bg-slate-200"></td>
                    <td class="py-4 px-1 lg:px-6 bg-slate-200"></td>
                    <td class="py-4 px-1 lg:px-6 bg-slate-200"></td>
                </tr>

                <tr>
                    <td class="py-4 px-1 lg:px-6">Fully Customizable digital Profile</td>
                    <td class="py-4 px-1 lg:px-6 border-x border-gray-200 flex-auto"><img
                            src="../../../../assets/icon_check.png" alt="icon"> </td>
                    <td class="py-4 px-1 lg:px-6 border-x border-gray-200 flex-auto"><img
                            src="../../../../assets/icon_check.png" alt="icon"></td>
                    <td class="py-4 px-1 lg:px-6 flex-auto"><img src="../../../../assets/icon_check.png" alt="icon">
                    </td>
                </tr>

                <tr>
                    <td class="py-4 px-1 lg:px-6">NFC tap technology</td>
                    <td class="py-4 px-1 lg:px-6 border-x border-gray-200 flex-auto"><img
                            src="../../../../assets/icon_check.png" alt="icon"> </td>
                    <td class="py-4 px-1 lg:px-6 border-x border-gray-200 flex-auto"><img
                            src="../../../../assets/icon_check.png" alt="icon"></td>
                    <td class="py-4 px-1 lg:px-6 flex-auto"><img src="../../../../assets/icon_check.png" alt="icon">
                    </td>
                </tr>

                <tr>
                    <td class="py-4 px-1 lg:px-6">QR code functionality</td>
                    <td class="py-4 px-1 lg:px-6 border-x border-gray-200 flex-auto"><img
                            src="../../../../assets/icon_check.png" alt="icon"> </td>
                    <td class="py-4 px-1 lg:px-6 border-x border-gray-200 flex-auto"><img
                            src="../../../../assets/icon_check.png" alt="icon"></td>
                    <td class="py-4 px-1 lg:px-6 flex-auto"><img src="../../../../assets/icon_check.png" alt="icon">
                    </td>
                </tr>

                <tr>
                    <td class="py-4 px-1 lg:px-6">Two lines of customizable text</td>
                    <td class="py-4 px-1 lg:px-6 border-x border-gray-200 flex-auto"></td>
                    <td class="py-4 px-1 lg:px-6 border-x border-gray-200 flex-auto"><img
                            src="../../../../assets/icon_check.png" alt="icon"></td>
                    <td class="py-4 px-1 lg:px-6 flex-auto"><img src="../../../../assets/icon_check.png" alt="icon">
                    </td>
                </tr>
                <tr>
                    <td class="py-4 px-1 lg:px-6">100% customizable card design</td>
                    <td class="py-4 px-1 lg:px-6 border-x border-gray-200 flex-auto"> </td>
                    <td class="py-4 px-1 lg:px-6 border-x border-gray-200 flex-auto"></td>
                    <td class="py-4 px-1 lg:px-6 flex-auto"><img src="../../../../assets/icon_check.png" alt="icon">
                    </td>
                </tr>

            </tbody>
        </table>

        
    </section>
</section> -->

<section [class]="'mx-auto px-4 sm:px-6 lg:px-0 bg-white ' + dir">
    <section class="lg:container lg:mx-auto py-5 lg:px-8 lg:py-16 2xl:px-16">
        <h2 class="text-center lg:text-4xl text-2xl font-semibold lg:mb-4">{{"SIMPLESTEPS.DESIGNYOURCARD"|translate}}
        </h2>
        <section class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10 py-5 gap-4 text-center ">
            <div class="none hidden absolute   2xl:ml-[192px] 2xl:mt-[4%] lg:ml-40 z-0 lg:mt-14 2xl:block lg:hidden">
                <figure class="mb-3 2xl:w-[300px]"><img src="../../../../assets/img_dot_arrow1.png" alt="step" />
                </figure>
            </div>
            <div class="none hidden absolute   2xl:ml-[554px]  2xl:mt-7 lg:ml-[35%] z-0 lg:mt-5 2xl:block lg:hidden">
                <figure class="mb-3  2xl:w-[300px]"><img src="../../../../assets/img_dot_arrow3.png" alt="step" />
                </figure>
            </div>
            <div class="none hidden absolute   2xl:ml-[915px]  2xl:mt-[4%]   lg:ml-[58%] z-0 mt-10 2xl:block lg:hidden">
                <figure class="mb-3  2xl:w-[300px]"><img src="../../../../assets/img_dot_arrow2.png" alt="step" />
                </figure>
            </div>

            <div class="none hidden absolute 2xl:hidden   lg:ml-40 z-0 lg:mt-14 lg:block">
                <figure class="mb-3 "><img src="../../../../assets/img_dot_arrow11.png" alt="step" />
                </figure>
            </div>
            <div class="none hidden absolute 2xl:hidden   lg:ml-[32%] z-0 lg:mt-5 lg:block">
                <figure class="mb-3  "><img src="../../../../assets/img_dot_arrow21.png" alt="step" />
                </figure>
            </div>
            <div class="none hidden absolute  2xl:hidden    lg:ml-[54%] z-0 mt-12 lg:block">
                <figure class="mb-3  "><img src="../../../../assets/img_dot_arrow31.png" alt="step" />
                </figure>
            </div>

            <div class="mb-2 p-3 2xl:p-8">
                <figure class="flex py-2 justify-center">
                    <img src="../../../../assets/img_card_type1.png" alt="icon" />
                </figure>
                <h2 class="lg:text-2xl text-xl text-black py-10 font-semibold">{{"SIMPLESTEPS.PURCHASECARD"|translate}}
                </h2>
                <p class="text-gray-800 2xl:text-xl"> {{"SIMPLESTEPS.PURCHASECARDCONTENT"|translate}}</p>
            </div>
            <div class="mb-2 p-3 2xl:p-8">
                <figure class="flex py-2 justify-center">
                    <img src="../../../../assets/img_card_type2.png" alt="icon" />
                </figure>
                <h2 class="lg:text-2xl text-xl text-black py-10  font-semibold">
                    {{"SIMPLESTEPS.PERSONALIZECARD"|translate}}</h2>
                <p class="text-gray-800 2xl:text-xl">{{"SIMPLESTEPS.PERSONALIZECARDCONTENT"|translate}}</p>
            </div>
            <div class="mb-2 p-3 2xl:p-8">
                <figure class="flex py-2 justify-center">
                    <img src="../../../../assets/img_card_type3.png" alt="icon" />
                </figure>
                <h2 class="lg:text-2xl text-xl text-black py-10  font-semibold">
                    {{"SIMPLESTEPS.CREATEPROFILE"|translate}}
                </h2>
                <p class="text-gray-800 2xl:text-xl">{{"SIMPLESTEPS.CREATEPROFILECONTENT"|translate}}</p>
            </div>
            <div class="mb-2 p-3 2xl:p-8">
                <figure class="flex py-2 justify-center">
                    <img src="../../../../assets/img_card_type4.png" alt="icon" />
                </figure>
                <h2 class="lg:text-2xl text-xl text-black py-10  font-semibold">{{"SIMPLESTEPS.RECEIVECARD"|translate}}
                </h2>
                <p class="text-gray-800 2xl:text-xl">
                    {{"SIMPLESTEPS.RECEIVECARDCONTENT"|translate}}</p>
            </div>
        </section>
    </section>
</section>

<section class="mx-auto px-4 sm:px-6 lg:px-0 bg-[#f6f5fa] bg-card-type">
    <section class="lg:container lg:mx-auto py-5 lg:px-8 lg:py-16">
        <div class="lg:w-[60%] mx-auto">
            <h2 class="text-center lg:text-4xl text-2xl font-semibold mb-5">{{"CARDTYPE.OURCARDTYPES"|translate}}</h2>
            <h3 class="text-center lg:text-2xl  text-xl font-semibold mb-5">{{"CARDTYPE.CHOOSEYOURCARD"|translate}}</h3>
            <p class="text-center text-secondary-light mb-5 2xl:text-xl">{{"CARDTYPE.PLANS"|translate}}</p>
        </div>
        <section class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10 py-5 gap-4 2xl:px-28 ">
            <div
                class="mb-2 bg-white rounded-2xl   drop-shadow-lg  p-5 hover:scale-105 hover:border-2 hover:border-black">

                <h2 class="lg:text-2xl text-xl text-black font-semibold mb-3">{{"CARDTYPE.MYDIGITAL"|translate}}</h2>
                <figure class="flex py-4 ">
                    <img src="../../../../assets/img_our_card1.png" alt="icon" />
                </figure>
                <p class="text-gray-800 mb-3 2xl:text-xl">{{"CARDTYPE.PLATFORMLICENCE"|translate}}</p>
                <p class="text-gray-800 2xl:text-xl">{{"CARDTYPE.NOPHYSICALCARD"|translate}}</p>
            </div>

            <div
                class="mb-2 bg-white rounded-2xl  drop-shadow-lg  p-5 hover:scale-105 hover:border-2 hover:border-black">

                <h2 class="lg:text-2xl text-xl text-black font-semibold mb-3">{{"CARDTYPE.MYSTANDARD"|translate}}</h2>
                <figure class="flex py-4 ">
                    <img src="../../../../assets/img_our_card2.png" alt="icon" />
                </figure>
                <p class="text-gray-800 mb-3 2xl:text-xl">{{"CARDTYPE.PLATFORMLICENCE"|translate}}</p>
                <p class="text-gray-800  2xl:text-xl">{{"CARDTYPE.NFCWITHQR"|translate}}</p>
            </div>

            <div
                class="mb-2 bg-white rounded-2xl  drop-shadow-lg  p-5 hover:scale-105 hover:border-2 hover:border-black">

                <h2 class="lg:text-2xl text-xl text-black font-semibold mb-3">{{"CARDTYPE.MYPERSONAL"|translate}}</h2>
                <figure class="flex py-4 ">
                    <img src="../../../../assets/img_our_card1.png" alt="icon" />
                </figure>
                <p class="text-gray-800 mb-3  2xl:text-xl">{{"CARDTYPE.PLATFORMLICENCE"|translate}}</p>
                <p class="text-gray-800 mb-3  2xl:text-xl">{{"CARDTYPE.NFCWITHQR"|translate}}</p>
                <p class="text-gray-800 2xl:text-xl ">{{"CARDTYPE.NAMEONCARD"|translate}}</p>
            </div>

            <div
                class="mb-2 bg-white rounded-2xl   drop-shadow-lg  p-5 hover:scale-105 hover:border-2 hover:border-black">

                <h2 class="lg:text-2xl text-xl text-black font-semibold mb-3">{{"CARDTYPE.MYBUSSINESS"|translate}}</h2>
                <figure class="flex py-4 ">
                    <img src="../../../../assets/img_our_card4.png" alt="icon" />
                </figure>
                <p class="text-gray-800 mb-3  2xl:text-xl">{{"CARDTYPE.PLATFORMLICENCE"|translate}}</p>
                <p class="text-gray-800 mb-3  2xl:text-xl">{{"CARDTYPE.NFCWITHQR"|translate}}</p>
                <p class="text-gray-800  2xl:text-xl">{{"CARDTYPE.CUSTOMIZEDESIGN"|translate}}</p>
            </div>
        </section>
    </section>
</section>